import React, { Component } from 'react';

import axios from 'axios';

import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSync } from '@fortawesome/free-solid-svg-icons'

import QRCode from 'qrcode.react'

import './PLRButton.css';


export default class PLRButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modal: null,
      loaded: undefined,
      friendRequest: null,
      systemFriendRequest: null,
    }
  }

  componentDidMount() {
    this.startLoading()
  }

  componentDidUpdate() {
    this.startLoading()
  }

  startLoading() {
    if (this.state.loaded !== undefined) {
      return
    }
    if (this.props.db && this.props.uid) {
      setTimeout(() => {
        this.setState({
          loaded: null,
        }, () => {
          this.loadState()
            .then((state) => {
              this.setState(state)
            })
            .catch((error) => {
              console.error(error)
              if (!this.props.onError) {
                return
              }
              this.props.onError(error)
            })
        })
      }, 100)
    }
  }

  closeEdit(e) {
    this.setState({
      modal: null,
    })
  }

  getUserDocument() {
    return this.props.db.collection('user').doc(this.props.uid)
  }

  async loadState() {
    await axios.post(`/plr/${this.props.uid}`)
    const user = await this.getUserDocument().get()
    if (!user.exists) {
      return {
        loaded: null
      }
    }
    const userData = user.data()
    const systemFriendRequest = userData.plrSource ?
      (userData.plrSource.rawFriendRequest || JSON.parse(userData.plrSource).rawFriendRequest) : null
    const systemFriendRequestHttp = userData.plrSource ?
      (userData.plrSource.httpWrappedURI || JSON.parse(userData.plrSource).httpWrappedURI) : null
    return {
      loaded: userData,
      plrConnected: userData.plrConnected,
      plrSource: userData.plrSource,
      systemFriendRequest,
      systemFriendRequestHttp,
      friendRequest: userData.friendRequest,
    }
  }

  friendRequestChange(event) {
    this.setState({
      friendRequest: event.target.value,
    })
  }

  addFriend() {
    this.performAddFriend()
      .then(() => {
        console.log('Added')
        this.closeEdit()
      })
      .catch((error) => {
        console.error(error)
        if (!this.props.onError) {
          return
        }
        this.props.onError(error)
      })
  }

  async performAddFriend() {
    await this.getUserDocument().update({
      friendRequest: this.state.friendRequest,
    })
    await axios.post(`/plr/${this.props.uid}`)
  }

  renderSystemFriendRequest() {
    return <div>
        <h4>
          1. Cloze TestをあなたのPersonaryにフレンド登録してください
        </h4>
        <p>
          あなたのPersonaryにて、フレンド登録を選択し、
        </p>
        <p>
          以下のQRコードを読み取るか、
        </p>
        <div>
          <QRCode value={this.state.systemFriendRequestHttp} />
        </div>
        <p>
          リクエスト文字列 <span>{this.state.systemFriendRequest}</span> を入力してください。
        </p>
      </div>
  }

  renderFriendRequestRegistration() {
    return <div>
      <h4>2. あなたのPersonaryのフレンド登録リクエストをCloze Testに送信してください</h4>
      <Form.Group>
        <Form.Label>あなたのフレンド登録リクエスト</Form.Label>
        <Form.Control
          placeholder='フレンドリクエスト文字列をここに貼り付けてください'
          onChange={e => this.friendRequestChange(e)} />
        <Button
          variant='success'
          data-test-friend-request-registration
          disabled={!this.state.friendRequest}
          onClick={e => this.addFriend()}>
          登録
        </Button>
      </Form.Group>
    </div>
  }

  render() {
    return <div>
      <Button
        data-test-cloze-plr
        variant='primary'
        disabled={this.state.systemFriendRequest === null}
        onClick={e => this.setState({
          modal: 'system_fr'
        })}>
        <FontAwesomeIcon icon={faSync} />
        {this.state.plrConnected ? 'PLR(Personary)と連携中' : 'PLR(Personary)と連携する(開発中)'}
      </Button>
      <Modal
        data-test-cell-modal-detail
        show={this.state.modal !== null}
        animation={true}
        onHide={e => this.closeEdit()}>
        <Modal.Header closeButton>
          <Modal.Title>PLRとの連携設定</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {this.state.modal === 'system_fr' &&
            this.renderSystemFriendRequest()}
          {this.state.modal === 'my_fr' &&
            this.renderFriendRequestRegistration()}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant='light'
            data-test-cell-detail-close
            onClick={e => this.closeEdit(e)}>
            閉じる
          </Button>
          {this.state.modal === 'system_fr' && <Button
              variant='success'
              data-test-plr-next
              onClick={e => this.setState({
                modal: 'my_fr'
              })}>
              次へ
            </Button>}
        </Modal.Footer>
      </Modal>
    </div>
  }
}
